import { notifiFail } from 'components/Common/FloatingNotifications/notifi';
import { takeLatest, put, call } from 'redux-saga/effects';
import { fetchFavouritePropertiesAction } from 'redux/actions/favouritePropertiesActions';
import ACREAPI from 'utils/services/ACREAPI';

function* fetchFavouritePropertiesSaga(action) {
    try {
        yield put(fetchFavouritePropertiesAction.request());

        const response = yield call(ACREAPI.favouriteProperties().index, action.payload);

        yield put(fetchFavouritePropertiesAction.success(response.data.favorite_listing.data));
    } catch (e) {
        notifiFail({
            message: 'Loading of favourites has been failed',
        });

        yield put(fetchFavouritePropertiesAction.failure());
    } finally {
        yield put(fetchFavouritePropertiesAction.fulfill());
    }
}

export default function* fetchFavouritePropertiesSagaWatcher() {
    yield takeLatest(fetchFavouritePropertiesAction.trigger, fetchFavouritePropertiesSaga);
}
